import React from 'react';
import { FormBuilder } from 'commons-ui';
import { IReject } from '../../types';
import {
	FORM_FIELD_CONFIG_REJECT_REQUEST,
	FORM_LAYOUT_CONFIG_REJECT_REQUEST,
	validationSchemaRejectRequest
} from '../../utils/formConfig';
import useReject from './useReject';

const Reject: React.FC<IReject> = (props) => {
	const { rowData, fetchConfiscationAndRefundData } = props;
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useReject(
		rowData.confiscationId,
		fetchConfiscationAndRefundData
	);

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchemaRejectRequest}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG_REJECT_REQUEST}
			layoutConfig={FORM_LAYOUT_CONFIG_REJECT_REQUEST}
			hidePopUp
		/>
	);
};

export default Reject;
